<template>
    <div v-if="is_open">
      <div class="watch-demo__overlay">
        <img @click.prevent="close()" class="watch-demo__close" src="/img/close-white.svg">
        <div class="watch-demo">
          <div class="watch-demo__header">
            <h3>Welcome to Pillar!</h3>
            <p class="text-secondary">Watch our short intro video to get you started</p>
          </div>
          <div class="watch-demo__body">
            <div class="wistia_responsive_padding" style="padding:68.96% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_0k5fqz2l4w videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/0k5fqz2l4w/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>
          </div>
          <div class="d-flex">
            <button @click.prevent="close()" class="ml-auto button button-m button-primary">Got it</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        props: {

        },
        data() {
          return {
              is_open: true
          }
        },
        computed: {
        },
        methods: {
          close() {
            this.is_open = false;
          }
        },
        watch: {
        }
    }
</script>

<style lang="scss">
  .watch-demo__overlay {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);

    .watch-demo {
      background: #FFFFFF;
      border-radius: 2px;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
      padding-top: 16px;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
      position: absolute;
      width: 100%;

      @include media('>=tablet') {
        width: auto;
        min-width: 640px;
        transform: translate(-50%, -50%);
      }

      .watch-demo__header {
        padding-bottom: 16px;

        h3, p {
          text-align: center;
        }

        h3 {
          font-size: 20px;
        }
      }

      .watch-demo__body {
        padding-bottom: 24px;
      }
    }

    .watch-demo__close {
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
      cursor: pointer;
      width: 24px;

      @include media('>=tablet') {
        width: 43px;
        right: 43px;
        top: 34px;
      }
    }
  }
</style>
